import { render, staticRenderFns } from "./OnoffReport.vue?vue&type=template&id=07740566&"
import script from "./OnoffReport.vue?vue&type=script&lang=js&"
export * from "./OnoffReport.vue?vue&type=script&lang=js&"
import style0 from "./OnoffReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports